import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { api } from '../../api/client';
import { useToast } from '../../context/ToastContext';
import '../../App.css';
import MembershipForm, { IMembershipFormData } from '../../components/forms/MembershipForm';
import { loadSeasonOptions, type SeasonOption } from '../../utils/seasonOptions';
import { translateError } from '../../utils/errorMessages';

const MembershipCreatePage: React.FC = () => {
  const { t } = useTranslation();
  const { addToast } = useToast();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [seasonOptions, setSeasonOptions] = useState<SeasonOption[]>([]);
  const navigate = useNavigate();

  useEffect(() => {
    loadSeasonOptions().then(setSeasonOptions).catch(() => setSeasonOptions([]));
  }, []);

  const submitHandler = async (data: IMembershipFormData) => {
    setLoading(true);
    setError(null);

    try {
      // The loose group / member / activity links were retired in the
      // membership→course refactor; the form no longer carries them.
      await api.memberships.create(data);
      setLoading(false);
      addToast(t('memberships.createTitle') + ' - ' + t('common.save') + '!', 'success');
      navigate('/admin/memberships');
    } catch (err: any) {
      const errorMessage = translateError(err, t);
      setError(errorMessage);
      addToast(t('common.error') + ': ' + errorMessage, 'error');
      setLoading(false);
    }
  };

  return (
    <div className="admin-form-page">
      <h2>{t('memberships.createTitle')}</h2>
      {error && <p className="error-message">{t('common.error')}: {error}</p>}
      <MembershipForm
        onSubmit={submitHandler}
        loading={loading}
        submitButtonText={t('memberships.createButton')}
        seasonOptions={seasonOptions}
        previewSeasons={seasonOptions}
      />
      <Link to="/admin/memberships" className="form-link">
        {t('memberships.goBack')}
      </Link>
    </div>
  );
};

export default MembershipCreatePage;
